<template lang="pug">
#research-foci
  v-list-item(v-for='(researchFocus, i) in researchFoci', :key='i')
    v-list-item-subtitle
      v-icon.mr-1 mdi-chevron-double-right
      span {{ researchFocus }}
</template>

<script setup>
defineOptions({
  name: 'PersonResearchFoci',
})

defineProps({
  researchFoci: {
    type: Array,
    required: true,
  },
})
</script>
